<form>
  <div class="row">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th>Data</th>
              <th>ID Operador</th>
              <th>Nome Projeto</th>
              <th>Quant. Depósitos</th>
              <th>Total Depósitos</th>
              <th>Ticket Médio Deposito</th>
              <th>Conversão Depósitos</th>
              <th>Quant. Saques</th>
              <th>Total Saques</th>
              <th>Ticket Médio Saque</th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let row of rows">
              <td>{{ row?.date | date : "dd/MM/yyyy" : "GMT" }}</td>
              <td>{{ row?.accountId || "-" }}</td>
              <td>{{ row?.nomeProjeto || "-" }}</td>
              <td>{{ row?.countDeposit ?? 0 }}</td>
              <td>{{ row?.totalDeposit ?? 0 | formatCurrency }}</td>
              <td>{{ row?.ticketDeposit ?? 0 | formatCurrency }}</td>
              <td>{{ row?.conversionDeposit ?? 0 | number : "1.2-2" }}%</td>
              <td>{{ row?.countWithDraw ?? 0 }}</td>
              <td>{{ row?.totalWithDraw ?? 0 | formatCurrency }}</td>
              <td>{{ row?.ticketWithDraw ?? 0 | formatCurrency }}</td>
            </tr>
            <tr *ngIf="rows.length == 0">
              <td colspan="10">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>